import { Factory } from 'miragejs';
// import faker from 'faker';

export default Factory.extend({
  url() {
    return 'https://mock.looker-embed.com?with=all&kinds=of&params';
    // return faker.internet.url();
  },
});
